






import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { windowHelper, CustomException } from '@tencent/ppd-base-libs';
import { isInWeixin } from '@tencent/wphk-components-common/utils/ua';
import { bothReport, setBiPrefix, setReportMethod } from '../report';

@Component({
  components: {

  },
})
export default class CIndex extends Vue {
  /** 数据上报前缀A.B，如果没有传入则是promotion.thirdappredirect */
  @Prop() public biPrefix?: string;
  /** 数据上报方法，如果没有传入，则是香港钱包的biHottag；接受两个参数事件名(A.B.C.D)和扩展字段({key:value}) */
  @Prop() public reportMethod?: Function;
  @Prop({
    type: Boolean,
    default: true,
  }) public isAutoRedirect;
  @Prop({
    type: String,
    default: '#FFFFFF',
  }) public btnColor;
  @Prop() public btnText!: string;  // btn文案
  @Prop() public actUrl!: string; // 活动页面
  @Prop() public urlSchema!: string;  // 小程序schema

  @Watch('actUrl')
  private watchActUrl(nVal) {
    if (nVal && this.isAutoRedirect && isInWeixin()) {
      this.go2Act();
    }
  }

  @Watch('urlSchema')
  private watchUrlSchema(nVal) {
    if (nVal && this.isAutoRedirect) {
      this.go2Act();
    }
  }

  private created() {
    setBiPrefix(this.biPrefix);
    setReportMethod(this.reportMethod);
  }

  private mounted() {
    bothReport('jump2actbtn.btn_brow');
    // 渲染后，直接跳转活动页（如果这时候，actUrl或urlSchema还是空怎么办？）
    if (this.isAutoRedirect) {
      this.go2Act(false); // 不需要告警，刚开始可能就是空的url
    }
  }

  private eClickBtn() {
    // 上报
    bothReport('jump2actbtn.btn_click');
    this.go2Act();
  }

  private go2Act(willAddrEmptyAlarm = true) {
    if (isInWeixin() && this.actUrl) {
      // 直接replace到活动页面
      windowHelper.replace(this.actUrl, 450);
      return;
    }
    if (this.urlSchema) {
      windowHelper.redirect(this.urlSchema, 450);
      return;
    }

    if (willAddrEmptyAlarm) {
      // 上报
      bothReport('jump2actbtn.no_urlorschema_brow');
      // 告警
      new CustomException('', 'AddressingEmtpyException', 'third-app-redirect');
    }
  }
}
